<div class="row mx-1 mb-2">
  <div class="col-md-12">
    <!-- <div class="d-flex align-items-center flex-nowrap step-header mb-2">
      <div class="step-circle">2</div>
      <h5 class="mb-0 step-title">
        Select Verified Contacts From the Left List to add them to the selected contacts panel on the right
      </h5>
    </div> -->
    <div class="campaign-step mb-3">
      <div class="step-circle">
        <span>2</span>
      </div>

      <div class="step-content">
        <h5 class="step-title mb-0">
          Select Verified Contacts From the Left List to add them to the selected contacts panel on the right
        </h5>
      </div>
    </div>
  </div>
</div>
<div class="row mx-1 mb-2">
  <div class="col-md-6 col-12">
    <mat-form-field class="w-100">
      <mat-label>Contact Lists</mat-label>
      <mat-select #select multiple class="ml-4 mt-3">
        <mat-select-trigger *ngIf="allSelected == true"> All </mat-select-trigger>
        <div class="select-all pt-3 pl-3">
          <mat-checkbox
            [(ngModel)]="allSelected"
            [ngModelOptions]="{ standalone: true }"
            (change)="toggleAllSelection()"
            >Select All</mat-checkbox
          >
        </div>
        <div class="pl-4">
          <mat-option (click)="optionClick()" *ngFor="let option of contactListOption" [value]="option._id">
            {{ option.name }}
          </mat-option>
        </div>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<form [formGroup]="SearchForm" (ngSubmit)="saveSearch()">
  <div class="row mx-1 mb-2 align-items-center">
    <mat-form-field class="col-sm-2 col-6">
      <mat-label> Search Name</mat-label>
      <input #searchCtrl matInput autocomplete="off" placeholder="Search name" name="name" formControlName="name" />
    </mat-form-field>
    <mat-form-field class="col-sm-2 col-6">
      <mat-label> Search Email</mat-label>
      <input #searchCtrl matInput autocomplete="off" placeholder="Search email" formControlName="email" />
    </mat-form-field>
    <mat-form-field class="col-sm-2 col-6">
      <mat-label> Search City</mat-label>
      <input #searchCtrl matInput autocomplete="off" placeholder="Search" name="csvGroupName" formControlName="city" />
    </mat-form-field>
    <mat-form-field class="col-sm-2 col-6">
      <mat-label> Search State</mat-label>
      <input #searchCtrl matInput autocomplete="off" placeholder="Search" name="csvGroupName" formControlName="state" />
    </mat-form-field>
    <mat-form-field class="col-sm-2 col-6">
      <mat-label> Search Zip</mat-label>
      <input #searchCtrl matInput autocomplete="off" placeholder="Search" name="csvGroupName" formControlName="zip" />
    </mat-form-field>
    <div class="col-sm-4 col-6">
      <button mat-flat-button color="primary">Filter</button>
      <button mat-stroked-button color="primary" (click)="listenToSearch()" name="reset search" class="ml-2">
        Reset
      </button>
    </div>
  </div>
</form>
<div class="row mx-1 mb-5 table-container">
  <div class="col-lg-7 mt-2 table-csv-record">
    <div class="table_base">
      <div class="table-responsive table_wrap">
        <h6 class="d-inline-block w-100 mb-0" *ngIf="isAllSelectedRecords">
          <span class="contact-head"
            >All <b> {{ csvRecordListCount }} </b>Records has been Selected</span
          >
          <button
            mat-button
            color="primary"
            (click)="$event.preventDefault(); createContact()"
            class="float-right contact-btn"
            type="button"
          >
            <b>+ New Contact</b>
          </button>
        </h6>
        <h6 class="d-inline-block w-100 mb-0" *ngIf="!isAllSelectedRecords">
          <span class="contact-head">Contact List</span>
          <button
            mat-button
            color="primary"
            (click)="$event.preventDefault(); createContact()"
            class="float-right contact-btn"
            type="button"
          >
            <b>+ New Contact</b>
          </button>
        </h6>
        <table mat-table [dataSource]="contactDataSource" class="mat-elevation-z2 w-100" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                color="primary"
                (change)="$event ? masterToggle($event) : null"
                [checked]="selection.hasValue() && isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <div>
                <mat-checkbox
                  color="primary"
                  (change)="toggleSelect(row, $event.checked); selection.toggle(row)"
                  (click)="$event.stopPropagation()"
                  [checked]="selection.isSelected(row)"
                >
                </mat-checkbox>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="contactStatus">
            <th mat-header-cell *matHeaderCellDef class="align-center">Valid Email</th>
            <td mat-cell *matCellDef="let element" class="align-center">
              <mat-icon class="text-danger" *ngIf="!element.hasValidEmail" matTooltip="Invalid contact">
                close</mat-icon
              >
              <mat-icon class="text-success" *ngIf="element.hasValidEmail" matTooltip="Valid contact"> done</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="addressStatus">
            <th mat-header-cell *matHeaderCellDef class="align-center">Valid Address</th>
            <td mat-cell *matCellDef="let element" class="align-center">
              <mat-icon class="text-danger" *ngIf="!element.hasValidAddress" matTooltip="Invalid address">
                close</mat-icon
              >
              <mat-icon class="text-success" *ngIf="element.hasValidAddress" matTooltip="Valid address"> done</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="firstName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">Name</th>
            <td mat-cell *matCellDef="let element" class="align-left">
              <ng-container> {{ element.firstName }} {{ element.lastName }} </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">Email</th>
            <td mat-cell *matCellDef="let element" class="align-left">{{ element.email }}</td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">Address</th>
            <td mat-cell *matCellDef="let element" class="align-left">
              <ng-container
                *ngIf="element.hasValidAddress && element.streetAddress && element.city && element.state && element.zip"
              >
                <div
                  [propertyAddress]="
                    element.streetAddress + ', ' + element.city + ', ' + element.state + ' ' + element.zip
                  "
                >
                  {{ element.streetAddress }}, {{ element.city }}, {{ element.state }} {{ element.zip }}
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  !element.hasValidAddress || !element.streetAddress || !element.city || !element.state || !element.zip
                "
              >
                <div>{{ element.streetAddress }} {{ element.city }} {{ element.state }} {{ element.zip }}</div>
              </ng-container>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="csvRecordColumnList; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: csvRecordColumnList"></tr>
        </table>
        <div class="flex_center w-100" *ngIf="contactDataSource.data.length == 0">
          <div class="notFound text-center noData">
            <div>
              <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
              <h4>No result found</h4>
            </div>
          </div>
        </div>
        <div class="flex_center w-100" *ngIf="isDataLoading">
          <div class="notFound text-center noData">
            <div>
              <mat-spinner diameter="30"></mat-spinner>
            </div>
          </div>
        </div>
      </div>
      <mat-paginator
        [length]="csvRecordListCount"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 20]"
        (page)="pageChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>

  <div class="col-lg-5 mt-2 table-csv-record">
    <div class="table_base">
      <div class="table-responsive table_wrap">
        <h6 class="d-inline-block w-100 mb-0">
          <span class="contact-head">Selected Contacts</span>
          <button
            mat-button
            color="primary"
            class="button"
            (click)="$event.preventDefault(); saveList()"
            class="float-right contact-btn"
          >
            <b>Save List</b>
          </button>
        </h6>

        <table mat-table [dataSource]="selectedContactData" class="mat-elevation-z2 w-100" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <div></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="firstName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left">Name</th>
            <td mat-cell *matCellDef="let element" class="align-left">
              <span *ngIf="element.firstName || element.lastName"> {{ element.firstName }} {{ element.lastName }}</span>
              <span *ngIf="!element.firstName && !element.lastName"> {{ element.fullName }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left" style="width: 60%">Email</th>
            <td mat-cell *matCellDef="let element" class="align-left">{{ element.email }}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="align-left"></th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button aria-label="delete" class="delete" (click)="deleteSelectedRecord(element)">
                <i class="material-icons" style="font-size: 20px"> delete </i>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="saveRecordColumnList; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: saveRecordColumnList"></tr>
        </table>
        <div class="flex_center w-100" *ngIf="selectedContactData?.data?.length == 0">
          <div class="notFound text-center noData">
            <div>
              <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
              <h4>No result found</h4>
            </div>
          </div>
        </div>
      </div>
      <!-- <mat-paginator #contactPaginator [pageSizeOptions]="[10, 20]" showFirstLastButtons> </mat-paginator> -->
      <mat-paginator
        [length]="allSelectedRecordListCount"
        [pageSize]="pageSize1"
        [pageIndex]="pageIndex1"
        [pageSizeOptions]="[10, 20]"
        (page)="pageChange1($event)"
        showFirstLastButtons
        #paginator1
      >
      </mat-paginator>
    </div>
  </div>
</div>

<ng-template #fetchCompsDialog>
  <div class="addGroupWrap">
    <h2 matDialogTitle class="text-left">Save List As</h2>
    <div mat-dialog-content class="pt-2">
      <div class="row">
        <div class="col-12 col-md-12">
          <mat-form-field class="small-form-field w-100">
            <mat-label>List Name</mat-label>
            <input matInput type="text" [(ngModel)]="saveInput" name="listName" />
          </mat-form-field>
          <span style="color: red" *ngIf="error">{{ error }}</span>
        </div>
      </div>
    </div>
    <mat-dialog-actions>
      <div class="w-100 text-right">
        <button mat-button (click)="closeDialog()">Cancel</button>
        <button class="ml-1" (click)="save(saveInput)" mat-flat-button color="primary">Apply</button>
      </div>
    </mat-dialog-actions>
  </div>
</ng-template>
